import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const successLookup = (cbInfo, response) => {
  // console.log('get users OK response:');
  // console.log(response.data);
  if (response.status === 200 || response.status === 201) {
    store.dispatch('getUser', response.data);
  }
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedLookup = (cbInfo, response) => {
  // console.log('get users error response:');
  // console.log(response);
  if (response.status === 304) {
    if (cbInfo && cbInfo.cbSuccess) {
      cbInfo.cbSuccess(response);
    }
    return;
  }
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (spid, userobj, cbInfo) => {
  const axiosOptions = {
    timeout: 10000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  if (userobj.user_id && userobj.user_id > 0) {
    const thisurl = `/api/v1/sp/${spid}/user/${userobj.user_id}`;
    Vue.$http.put(thisurl, userobj, axiosOptions)
     .then((response) => {
       successLookup(cbInfo, response);
     })
     .catch((error) => {
       failedLookup(cbInfo, error);
     });
  } else {
    const thisurl = `/api/v1/sp/${spid}/user`;
    Vue.$http.post(thisurl, userobj, axiosOptions)
     .then((response) => {
       successLookup(cbInfo, response);
     })
     .catch((error) => {
       failedLookup(cbInfo, error);
     });
  }
};



// WEBPACK FOOTER //
// ./src/app/services/account/setcustomeruser.js